import { BasicSettingsPageContent } from './BasicSettingsPageContent'
import { withDefaultErrorBoundary } from '@/modules/shared/hoc/withDefaultErrorBoundary'

export const BasicSettingsPage = withDefaultErrorBoundary(BasicSettingsPageContent)
